import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import PropTypes from 'prop-types';
import EventTypePicker from './EventTypePicker';
import GuestTypes from './GuestTypes';
import SingleCalendar from './Calendar/SingleCalendar';
import useQuoteModal from './useQuoteModal';
import DatePriceStatus from './DatePriceStatus';
import { requestDatePrice } from '../redux/actions/datePrice';

function QuoteIntro({config, quote, dispatch}) {

  const [showModal, setShowModal] = useQuoteModal(true);
  const previousEventType = useRef();
  const eventTypeId = quote.eventType.id;
  useEffect(() => {
    // QuoteIntro remains mounted when Change Details closes. Type changes must
    // reprice even if its calendar has already unmounted during the transition.
    if (previousEventType.current && previousEventType.current !== eventTypeId) {
      dispatch(requestDatePrice(quote.selectedDate.date));
    }
    previousEventType.current = eventTypeId;
  }, [eventTypeId, dispatch, quote.selectedDate.date]);

  let imageUrl = 'none';
  if (_.isEmpty(config)) {
    return null;
  }
  if (!_.isNull(config.location.image_id)) {
    imageUrl =
      'url(' +
      config.appUrl +
      '/quote/image/' +
     config.location.id +
      ')';
  }


  return (
    <React.Fragment>
      {!showModal && <DatePriceStatus />}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className={'event-details-modal quote-dialog'}
        aria-labelledby="quote-details-title"
        centered
      >
        <Modal.Header>
          <h3 id="quote-details-title">Change Quote Details</h3>
          <button type="button" className="dialog-close" aria-label="Close quote details" onClick={() => setShowModal(false)}>×</button>
        </Modal.Header>
        <Modal.Body className={'modal-text'}>
          <SingleCalendar />
          <EventTypePicker eventTypes={config.bookingTypes} eventType={quote.eventType}/>
          <h5>Guest Numbers</h5>
          <GuestTypes />
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-primary" onClick={() => setShowModal(false)}>Start Quote</button>
        </Modal.Footer>
      </Modal>

      <div className={'quote-intro-container'}>
        <div className={'container'}>
          <div className="row">
            <div className="col-12 col-sm">
              <h2 className={'quote-heading'}>Create your event quote</h2>
            </div>
            <div className="col-12 col-sm-auto">
              <button
                type="button"
                onClick={() => setShowModal(true)}
                className={'btn btn-primary'}
              >
                Change Details
              </button>
            </div>
          </div>

          <div className={'row quote-intro-row'}>
            <div className={'col-12 col-sm-8 py-4 event-details-col'}>
              <div className={'col-12'}>
                <h2 className={'event-details-header'}>
                  {config.location.name}
                </h2>
              </div>

              <div className={'col-auto mr-1'}>
                <div className={'event-detail-text'}>
                  {moment(quote.selectedDate.date).format(
                    'ddd Do MMMM YYYY',
                  )}
                </div>
                <div className={'event-detail-text pl-3'}>
                  {quote.eventType.name}
                </div>
                <div className={'row'}>
                  <div className="col event-detail-text">
                    <ul className={'list-inline'}>
                      {_.map(quote.guests, (item) => {
                        return (
                          <li key={item.id} className="list-inline-item">
                            {item.total} {item.name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>

              {/* <EventDetails /> */}
              <div className={'quote-intro-description'}></div>
            </div>
            <div className={'col-12 col-sm-4 location-image-col'}>
              <div
                style={{ backgroundImage: imageUrl, height: '100%' }}
                className={'location-image'}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

}

QuoteIntro.propTypes = {
  config: PropTypes.object,
  quote: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    quote: state.quote,
    config: state.config,
  };
}

export default connect(mapStateToProps)(QuoteIntro);
